module.exports = __webpack_public_path__ + "static/media/close_btn.347f251e.svg";